export const IMAGES_RESOLUTIONS = [
    {
        media: '(min-width: 1160px)',
        config: { width: 320, height: 270 },
    },
    {
        media: '(min-width: 900px)',
        config: { width: 550, height: 305 },
    },
    {
        media: '(min-width: 600px)',
        config: { width: 420, height: 250 },
    },
];
